import { find, get, head } from "lodash";
import { MDBSpinner } from "mdbreact";
import React, { Component } from "react";
import Loadable from "react-loadable";
import { connect } from "react-redux";
import { withTitle } from "~/components/common/molecules/TitleHelmet";
import LoadableLoading from "~/components/mobile/molecules/LoadingPage";
import { partnerInfo } from "~/configs/partnerDetails";
import {
  hideModalConfirmSelectedSpecialist,
  setSearchPattern
} from "~/store/dateAndSpecialist/dateAndSpecialistActions";
import {
  changeDirection,
  getBookingTree,
  goBackStep,
  resetListNode,
  resetSelectDoctor,
  searchDoctor,
  selectDoctor
} from "~/store/totalData/actions";
import { DOCTOR } from "~/utils/constants";
import {
  filterListByParams,
  getFilterList,
  getPartnerFromUrl
} from "~/utils/func";
import { validateName, validateValue } from "~/utils/getReplaceUTF8";
const info = get(partnerInfo, "info");
const hospitalName = find(info, { key: "name" });

const ChooseDoctorPageDesktop = Loadable({
  loader: () => import("~/components/desktop/pages/Schedules/ChooseDoctor"),
  loading: LoadableLoading
});

const RESULT_PER_PAGE = 50;

class DetectChooseDoctor extends Component {
  constructor(props) {
    super(props);
    this.props.hideModalConfirmSelectedSpecialist();
    this.state = {
      name: "",
      role: "Học hàm / học vị",
      subject: "Chuyên khoa",
      gender: { text: "Giới tính", value: -1 },
      doctorListShow: [],
      listGender: [
        { value: -1, text: "Giới tính" },
        { value: 0, text: "Nữ" },
        { value: 1, text: "Nam" }
      ],
      filterListSubject: this.props.subjectList,
      page: 1
    };
  }

  getListDoctorToShow = listAfterFilter => {
    const arr = [...listAfterFilter];
    const listArr = [];
    let finalArr = [];

    while (arr.length) {
      listArr.push(arr.splice(0, RESULT_PER_PAGE));
    }

    for (let i = 0; i < listArr.length; i++) {
      if (i <= this.state.page - 1) {
        finalArr = [...finalArr, ...listArr[i]];
      }
    }
    return finalArr;
  };

  methods = {
    handleGoBack: () => {
      this.props.goBackStep("doctor");
    },
    onSearchName: e => {
      const value = e.target.value;
      this.setState({ name: validateValue(value), page: 1 });
    },
    selectRole: role => {
      this.setState(role);
      this.setState({ page: 1 });
    },
    selectSubject: subject => {
      this.setState(subject);
      this.setState({ page: 1 });
    },
    selectGender: gender => {
      this.setState({ gender, page: 1 });
    },
    filterSubject: e => {
      const value = e.target.value;
      const { subjectList } = this.props;
      const filterSubjectList = subjectList.filter(item => {
        const _name = validateName(item?.subject?.toLowerCase());
        const _value = validateValue(value?.toLowerCase());
        return _name.includes(_value);
      });
      this.setState({
        filterListSubject: filterSubjectList
      });
    },
    handleSeeMoreDoctor: page => {
      this.setState({ page: this.state.page + 1 });
    }
  };

  componentDidMount() {
    const {
      doctorList,
      isDirectionBack,
      selectDoctor,
      resetListNode,
      resetSelectDoctor,
      subjectList,
      getBookingTree
    } = this.props;

    const currentPagePartnerId = getPartnerFromUrl(
      this.props.history.location.pathname
    );

    resetSelectDoctor();
    resetListNode(DOCTOR);

    if (subjectList.length === 0) {
      getBookingTree("", currentPagePartnerId);
    }

    if (doctorList.length === 1) {
      if (isDirectionBack) {
        this.methods.handleGoBack();
      } else {
        const doctor = head(doctorList);
        selectDoctor(doctor);
        this.methods.handleNextStep(doctor.subType);
      }
    }
  }

  componentWillUnmount() {
    this.props.setSearchPattern("");
    this.props.hideModalConfirmSelectedSpecialist();
  }

  render() {
    const { doctorList } = this.props;
    const { role, subject, gender, name } = this.state;
    const params = {
      role,
      subject,
      gender: gender.value,
      name
    };

    if (doctorList.length === 0) {
      return (
        <div className="loading">
          <MDBSpinner big />
        </div>
      );
    }

    const listDoctorFilter =
      filterListByParams(doctorList, params) || doctorList;

    const listDoctorShow = this.getListDoctorToShow(listDoctorFilter);

    const isLastPage =
      Math.ceil(listDoctorFilter.length / RESULT_PER_PAGE) === this.state.page;

    return (
      <React.Fragment>
        <ChooseDoctorPageDesktop
          {...this.props}
          {...this.methods}
          {...this.state}
          listDoctorFilter={listDoctorShow}
          isLastPage={isLastPage}
        />
      </React.Fragment>
    );
  }
}

const mapStateToProps = state => {
  const {
    global: {
      device: { type }
    },
    hospital: { selectedHospital },
    totalData: {
      doctor: {
        id: idDoctor,
        list: doctorList,
        subType: subTypeDoctor,
        name: doctorName
      },
      listNode,
      isDirectionBack,
      partnerId,
      treeID,
      subject: selectedSubject
    }
  } = state;

  const roleList = getFilterList(doctorList, "role");
  const subjectList = getFilterList(doctorList, "subject");

  return {
    treeID,
    device: type,
    selectedHospital,
    idDoctor,
    subTypeDoctor,
    doctorName,
    listNode,
    doctorList,
    isDirectionBack,
    partnerId,
    roleList,
    subjectList,
    selectedSubject
  };
};

const DetectChooseDoctorHelmet = withTitle({
  component: DetectChooseDoctor,
  title: `${hospitalName.value} | Chọn bác sĩ`
});

export default connect(mapStateToProps, {
  setSearchPattern,
  hideModalConfirmSelectedSpecialist,
  searchDoctor,
  selectDoctor,
  changeDirection,
  resetListNode,
  goBackStep,
  resetSelectDoctor,
  getBookingTree
})(DetectChooseDoctorHelmet);
